<template>
  <div id="app" >
      <div class="top" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'center 0'}"> 

      </div>
      <div class="menu1" @click="menuClick1()">        
        <img class="btnimg" src="../assets/appointment.png" @click="menuClick1()">
        <div @click="menuClick1()">在线预约</div>
        <div @click="menuClick1()" style="color:#c0c0c0">线上预约，节省时间</div>
      </div>
      <div class="menu2" @click="menuClick2()">
        <img class="btnimg" src="../assets/排队.png" @click="menuClick2()">     
        <div @click="menuClick2()">排队进度</div>    
        <div @click="menuClick2()" style="color:#c0c0c0">快速查看排队进度</div>
      </div>
      <div class="menu3" @click="menuClick3()">        
        <img class="btnimg" src="../assets/我的预约.png" @click="menuClick3()">
        <div @click="menuClick3()">我的预约</div>
        <div @click="menuClick3()" style="color:#c0c0c0">查看我的预约情况</div>
      </div>
      <div class="menu4">
        <div id="cell">更多功能</div>
      </div>
      <div class="banner">
        <img id="bannerimg" src="../assets/banner.png">
      </div>
  </div>
  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'app',
  data () {
    return {
      msg: '这里是预约管理主页面',
      bg: require('../assets/top2.png'),
      btn1: require('../assets/appointment.png'),
      btn2: require('../assets/排队.png'),
      btn3: require('../assets/我的预约.png'),
      banner:require('../assets/banner.png'),
      vipname:'',
      wxopenid:'',
      wxbaseinfo:{
        openid:'',
        name:'',
        sex:'',
        idnumber:'',
        tel:'',
        status:''
      }
    }
  },
  created(){    
    // 1、从缓存读取openid    
    var temopenid= "oym4F6GbgItOvrqilutyj4W-y5Rw";//localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.wxopenid=temopenid
        this.wxbaseinfo.openid=temopenid;
        // 验证基本信息（是否有姓名）,无信息则完善基本信息
        this.checkInfo();
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxbaseinfo.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                // 跳转到授权页
                this.$router.push({path:'/authtest'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{
                  // 信息完事，则正常显示 
                  this.msg=response.data.data.name;
                }
              }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 验证是否已有排队信息
    checkAppointmentInfo(){

    },
    // 预约
    menuClick1(){
      this.$router.push({path:'/appointmentonlinetest'});
    },
    // 排队
    menuClick2(){
      this.$router.push({path:'/queulist'});
    },
    // 我的预约
    menuClick3(){      
      this.$router.push({path:'/appointmentlist'});
    }
  }
}
</script>

<style>
#app,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
span{
  line-height:32px;
      font-size:14px;
      font-weight:400;
      color:#1790ED;
      text-align:center;
}
#bannerimg{
  width: 100%;
  height: 100%;
  object-fit:cover;
  border-radius: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
}
#btnimg{
  width: 32px;
  height: 32px;
  object-fit:cover;
}
#app{
  position: relative;
}
.top {
  width: 100%;
  height: 240px;
  background-color: #0593d3;
  margin: 0;
}
.menu1{
  width: 46%;
  height: 110px;
  text-align: center;
  /* background-color:rgba(white, white, white,0.9); */
  background-color: white;
  margin: 10px;
  border-radius:5px;  
  float: left;
  position: absolute;
  top: 110px;
  border: 1px solid #bfbfbf;
  box-shadow: 0px 0px 6px 2px #aaa;
  filter: opacity(50);  
}

.menu2{
  width: 46%;
  height: 110px;
  text-align: center;
  background-color: white;
  margin: 10px;
  border-radius:5px;  
  float: right;
  position: absolute;
  top: 110px;
  left: 49%;
  border: 1px solid #bfbfbf;
  box-shadow: 0px 0px 6px 2px #aaa;
  filter: opacity(50);
}

.menu3{
  width: 46%;
  height: 110px;
  text-align: center;
  background-color: white;
  margin: 10px;
  border-radius:5px;  
  float: left;
  position: absolute;
  top: 230px;
  border: 1px solid #bfbfbf;
  box-shadow: 0px 0px 6px 2px #aaa;
  filter: opacity(8);
}

.menu4{
  width: 46%;
  height: 110px;
  text-align: center;
  background-color: white;
  margin: 10px;
  border-radius:5px;  
  float: right;
  position: absolute;
  top: 230px;
  left: 49%;
  border: 1px solid #bfbfbf;
  box-shadow: 0px 0px 6px 2px #aaa;
  filter: opacity(50);
  display:table;
}
#cell{
  display:table-cell; 
  vertical-align:middle;
  }

.banner{
  width: 94%;
  height: 33%;
  background-color: white;
  margin: 10px;
  border-radius:9px;  
  position: absolute;
  bottom: 10px;
  left:2px;
  border: 1px solid #bfbfbf;
  box-shadow: 0px 0px 10px 5px #aaa;
  filter: opacity(50);
}

</style>


// WEBPACK FOOTER //
// src/components/appointment.vue